import { useState } from "react";
import { useDispatch } from "react-redux";
import toast from "react-hot-toast";
import { processCheckout } from "../redux/checkoutSlice";
import { v4 as uuid } from "uuid";

export const useCheckout = (
    defuktAddr,
    gstinEnabled,
    gstinData,
    checkoutData,
    navigate
) => {
    const dispatch = useDispatch();
    const [errors, setErrors] = useState({});

    const handlePlaceOrder = () => {
        toast.dismiss();

        if (!defuktAddr) {
            toast.error("Please Add address before continue payment");
            return;
        }

        const orderPayload = {
            billing_first_name: defuktAddr.first_name,
            billing_last_name: defuktAddr.last_name,
            billing_mobile: defuktAddr.mobile,
            billing_address: defuktAddr.address,
            billing_address2: defuktAddr.address2,
            billing_landmark: defuktAddr.landmark,
            billing_city: defuktAddr.city,
            billing_state: defuktAddr.state,
            billing_pincode: defuktAddr.pincode,
            shipping_first_name: defuktAddr.first_name,
            shipping_last_name: defuktAddr.last_name,
            shipping_mobile: defuktAddr.mobile,
            shipping_address: defuktAddr.address,
            shipping_address2: defuktAddr.address2,
            shipping_landmark: defuktAddr.landmark,
            shipping_city: defuktAddr.city,
            shipping_state: defuktAddr.state,
            shipping_pincode: defuktAddr.pincode,
            business_details: gstinEnabled
                ? [
                    {
                        company_name: gstinData.companyAddress,
                        gst_number: gstinData.registrationNumber,
                    },
                ]
                : [],
        };

        dispatch(processCheckout(orderPayload))
            .unwrap()
            .then((res) => {
                navigate(`/checkout/payment/${uuid()}`, {
                    state: {
                        orderResponse: res,
                        orderPayload,
                        checkoutData,
                    },
                });
            })
            .catch(() => {
                toast.error("Something went wrong");
            });
    };

    return { handlePlaceOrder, errors, setErrors };
};
